import { AppChrome } from "./AppChrome";

/**
 * Верхняя зона шапки: сплошная панель под кнопками TG + матовый AppChrome.
 * Один sticky-блок — контент скроллится под нижнюю (стеклянную) часть.
 */
export function AppChromeStack({ onOpenBonuses, balanceSyncKey }) {
  return (
    <div className="appChromeStack">
      <div className="appChromeTopPad" aria-hidden />
      <AppChrome onOpenBonuses={onOpenBonuses} balanceSyncKey={balanceSyncKey} />
    </div>
  );
}
